import { Injectable } from '@angular/core';
import { ApiService } from '../abstract/api-service.abstract';
import { Observable } from 'rxjs/internal/Observable';
import { RegulatoryActivityModel } from '../models/regulatory-activity.models';
import { map } from 'rxjs/operators';
import { RegulatoryActivityDetail } from '../models/regulatory-activity-detail.model';

@Injectable({
  providedIn: 'root',
})
export class RegulatoryActivityService extends ApiService {
  list(
    filter: Partial<RegulatoryActivityModel> = {},
  ): Observable<{ count: number; data: RegulatoryActivityModel[] }> {
    const url = `${this.apiFrontUrl}/reg-plan/list?date=${this.cacheUid()}`;

    return this.http
      .get<{ count: number; data: any[] }>(url, { params: filter })
      .pipe(
        map((data) => {
          return {
            count: data.count,
            data: data.data.map((item) =>
              RegulatoryActivityModel.fromJson(item),
            ),
          };
        }),
      );
  }

  getPlanById(id: string): Observable<RegulatoryActivityDetail> {
    return this.http.get<RegulatoryActivityDetail>(
      `${this.apiFrontUrl}/reg-plan/${id}?date=${this.cacheUid()}`,
    );
  }

  getAllRegulatorTitles(): Observable<string[]> {
    return this.list({ take: 1000, skip: 0 }).pipe(
      map((res) =>
        Array.from(new Set(res.data.map((item) => item.regulatorTitle))).filter(
          (v): v is string => typeof v === 'string' && !!v,
        ),
      ),
    );
  }
}
